import { type FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import { type OnLinkClick } from './SharedPaginationTypes';

import { getNewPaginationUriRef } from '../../utils/uriUtils';

import { SharedPaginationArrowItem } from './SharedPaginationArrowItem';
import { SharedPaginationPageItem } from './SharedPaginationPageItem';

type Props = {
    type: 'back' | 'page' | 'ellipsis' | 'forward';
    pageNumber: number;
    isSelected: boolean;
    currentPage: number;
    uriRef: string;
    onLinkClick: OnLinkClick;
    hideHref?: boolean;
};

export const SharedPaginationItem: FC<Props> = ({
    type,
    pageNumber,
    isSelected,
    currentPage,
    uriRef,
    onLinkClick,
    hideHref,
}) => {
    switch (type) {
        case 'back': {
            const href = getNewPaginationUriRef(uriRef, currentPage - 1);
            return (
                <SharedPaginationArrowItem
                    isLeft
                    onClick={e => onLinkClick({ e, href, pageNumber: currentPage - 1 })}
                    dataTn={`page-${type}`}
                    href={hideHref ? undefined : href}
                >
                    <FormattedMessage id="SharedPagination.previous" defaultMessage="Previous" />
                </SharedPaginationArrowItem>
            );
        }
        case 'page': {
            const dataTn = `page-${pageNumber}${isSelected ? '-selected' : ''}`;
            const href = getNewPaginationUriRef(uriRef, pageNumber);
            return (
                <SharedPaginationPageItem
                    isSelected={isSelected}
                    dataTn={dataTn}
                    onClick={e => onLinkClick({ e, href, pageNumber })}
                    href={hideHref ? undefined : href}
                >
                    {pageNumber}
                </SharedPaginationPageItem>
            );
        }
        case 'ellipsis': {
            return <span>...</span>;
        }
        case 'forward': {
            const href = getNewPaginationUriRef(uriRef, currentPage + 1);
            return (
                <SharedPaginationArrowItem
                    onClick={e => onLinkClick({ e, href, pageNumber: currentPage + 1 })}
                    dataTn={`page-${type}`}
                    href={hideHref ? undefined : href}
                >
                    <FormattedMessage id="SharedPagination.next" defaultMessage="Next" />
                </SharedPaginationArrowItem>
            );
        }
        default: {
            return null;
        }
    }
};
